import {Component} from '@angular/core';
import {NotificationsService} from 'angular2-notifications';
import {Router, ActivatedRoute} from '@angular/router';
import AuthService from "../../services/auth.service";
import IUser from "../../interfaces/IUser";

@Component({
    selector: 'login',
    template: require('./login.component.html'),
    styles: [String(require('./login.styl'))]
})

export class LoginComponent {
    private notificationOptions = {
        position: ['top', 'left'],
        timeOut: 5000,
        preventDuplicates: 1
    }
    public user: IUser;
    public password: string;
    private loginAttempt: boolean = false;

    constructor(private authService: AuthService,
                private notificationsService: NotificationsService,
                private router: Router,
                private activatedRoute: ActivatedRoute) {
        this.user = this.authService.user;

        this.activatedRoute.params.subscribe((params: any) => {
            if (params.username && params.passwordHash) {
                this.user.name = params.username;
                this.authService.loginByHash(this.user, params.passwordHash).subscribe(this.loginSuccess, this.loginError);
            }
        })

    }

    public login() {
        this.loginAttempt = true;
        if (!this.password || !this.user.name) {
            return false;
        }
        this.authService.login(this.user, this.password).subscribe(this.loginSuccess, this.loginError);
    }

    private loginError = (error) => {
        const errorMsg = (error.inactive) ? "Sorry but this user is inactive... Please contact us at support@scislo.eu" : 'Sorry but your username or password is not correct...';
        this.notificationsService.error('Unable to login!', errorMsg)
    }

    private loginSuccess = () => {
        this.router.navigate(['/measurements'])
    }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts